<div class="container animated fadeInRight">
  <div [formGroup]="formulario" novalidate>
    <app-lfsa-card [innTemplate]="requisicion" [titulo]="'BUSCAR'" [efecto]="true"
      [colapseName]="'requisicion'" [banderaColapse]='true'></app-lfsa-card>
    <ng-template #requisicion>
      <form [formGroup]="formulario" novalidate class="form-group">
        <div class="row">
          <div [class]="'col-md-4'">
            <app-lfsa-input [claseLabel]="'letrasDanger'" [mostrarImg]="false" [control]="formulario.get('numeroReuqisicion')"
              [placeholder]="'Pulsar enter para buscar'" formControlName="numeroReuqisicion"
              [label]="'Cédula'" [type]="'text'" [id]="'numeroReuqisicion'"
              (keydown.enter)="getDataRequisicion()" (keydown.tab)="getDataRequisicion()">
            </app-lfsa-input>
          </div>
          
        </div>
      </form>
      <br>
    </ng-template>

    <app-lfsa-card *ngIf="mostrarCard" [innTemplate]="datosRequisicion" [titulo]="'REPORTE HISTORICO'" [efecto]="true"
      [colapseName]="'datosRequisicion'" [banderaColapse]='true'></app-lfsa-card>
    <ng-template #datosRequisicion>

      <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <div *ngIf="!loading">
      <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
        No existen datos para la lista de Reporte.
      </div>
      <ag-grid-angular *ngIf="!listaVacia" #agGrid class=" {{empModulo.agGrid.class}}"
        [ngStyle]="empModulo.agGrid.style" id="{{empModulo.agGrid.id}}" [frameworkComponents]="frameworkComponents "
        [columnDefs]="columnDefs" [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)"
        [pagination]="true" [paginationPageSize]="empModulo.agGrid.paginacion">
      </ag-grid-angular>
    </div>
    <br>
    </ng-template>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <div *ngIf="!loading" class="row">
      <div class="form-group col-md-6">
        <button [routerLink]="['/emp/administrador/home-emp']" class="btn btn-outline-danger btn-block btn-lg">Regresar</button>
      </div>
      <div class="form-group col-md-6">
        <button [routerLink]="['/emp/administrador/home-emp']" class="btn btn-success btn-block btn-lg" (click)="downloadHistoricoExcel()">Descargar</button>
      </div>
      
    </div>
  </div>
</div>

<!-- MODAL -->
<app-lfsa-modal [innTemplate]="enviarModal" [titulo]="'Editar Punto de Reorden'" [idButton]="'abrirModal'" [idOpen]="'Modal'"
  [idClose]="'cerrarModal'"></app-lfsa-modal>
<ng-template #enviarModal>
  <form [formGroup]="formulario" novalidate class="form-group">
  <div class="row">
      <div [class]="'col-md-6'">
        <h5> <b>Fecha:</b>&nbsp;{{ dataEdit.odat }} </h5>
      </div>
      <div [class]="'col-md-6'">
        <h5><b>C.C:</b>&nbsp;{{ dataEdit.dimx }} </h5>
      </div>
      <div [class]="'col-md-6'">
        <h5><b>Artículo:</b>&nbsp;{{ dataEdit.item + ' ' + dataEdit.cntr }} </h5>
      </div>
      <div [class]="'col-md-6'">
        <h5><b>Cantidad Entregada:</b>&nbsp;{{ dataEdit.dqua }} </h5>
      </div>
      
    </div>
    <div class="row">
      <div [class]="'col-md-12'">
        <app-lfsa-input [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formulario.get('puntoReorden')"
          [placeholder]="'Punto de Reorden'" formControlName="puntoReorden" [label]="'Punto de Reorden*'" [type]="'number'"
          [id]="'puntoReorden'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
        <div *ngIf="!loading">
          <label>&nbsp;</label><br>
          <button class="btn btn-success btn-block" [disabled]="formulario.invalid"
            (click)="updatePuntoReorden()">Guardar</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<!-- {{ rowData | json }} -->
<br>